import type { TCatFormDataInput } from "@./suf-store";

export const normaliseCatFormDataForCheckout = (catData: TCatFormDataInput): TCatFormDataInput => ({
  ...catData,
  name: catData.name?.trim(),
});

export const normaliseCatsFormDataForCheckout = (
  cats: Record<string, TCatFormDataInput>,
): Record<string, TCatFormDataInput> => {
  const normalisedCats: Record<string, TCatFormDataInput> = {};
  Object.entries(cats).forEach(([ key, data ]) => {
    normalisedCats[key] = normaliseCatFormDataForCheckout(data);
  });

  return normalisedCats;
};
